'use strict';
import React from 'react';

class NotFoundComponent extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'NotFoundComponent';
    }
    render() {
        return <div>NotFoundComponent</div>;
    }
}

export default NotFoundComponent;




// WEBPACK FOOTER //
// ./src/components/notFound.jsx